import moment from 'moment';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import _extend from 'lodash/extend';
import _orderBy from 'lodash/orderBy';
import _reject from 'lodash/reject';

import inventoryUtils from 'utils/inventoryUtils';
import config from 'src/config';

function InventoryListCtrl($scope, $state, $stateParams, $q, $timeout, venueService, inventoryService, scheduleService,
  sdkUtils, permissionService, dateUtilsService, alertService, visibilityHelpersService, modalService, angularSlideOutPanel, printService) { //eslint-disable-line
  if (!$scope.venue) throw new Error('venue is required');
  $scope.type = $scope.type || 'TICKET';

  if ($scope.schedule && !$scope.day) throw new Error('day is required');
  else if (!$scope.schedule && !$scope.date) throw new Error('date is required');

  $scope.ticketCount = function () {
    return _filter($scope.inventory, inv => {
      const typeFilter = inv.type === 'TICKET';
      const dayFilter = $scope.day && $scope.day.number ? inv.day === $scope.day.number : ((!$scope.schedule) ? true : false); //eslint-disable-line
      return typeFilter && dayFilter && inv.enable;
    }).length;
  };
  $scope.tableCount = function () {
    const total = _filter($scope.inventory, inv => {
      const typeFilter = inv.type === 'TABLE' || inv.type === 'PACKAGE';
      const dayFilter = $scope.day && $scope.day.number ? inv.day === $scope.day.number : ((!$scope.schedule) ? true : false); //eslint-disable-line
      return typeFilter && dayFilter && inv.enable;
    });

    return total.length;
  };
  $scope.coverCount = function () {
    return _filter($scope.inventory, inv => {
      const typeFilter = inv.type === 'COVER';
      const dayFilter = $scope.day && $scope.day.number ? inv.day === $scope.day.number : ((!$scope.schedule) ? true : false); //eslint-disable-line
      return typeFilter && dayFilter && inv.enable;
    }).length;
  };

  $scope.isNotBeforeToday = function (inventory) {
    const today = moment();

    return !moment(inventory.date.toString()).isBefore(today);
  };

  $scope.filteredInventory = function () {
    const inventory = _filter($scope.inventory, item => {
      if (!item || !item.type) return null;

      const typeMatches = ($scope.type === 'TABLE') ?
        (item.type === 'TABLE' || item.type === 'PACKAGE') :
        item.type === $scope.type;

      let dayMatches = true;
      let enabledMatches = true;

      if ($scope.schedule) dayMatches = item.day === $scope.day.number;

      if ($scope.hideHiddenInventory) enabledMatches = item.enable;

      return typeMatches && dayMatches && enabledMatches;
    });

    return _orderBy(inventory, ['price', 'location'], ['asc', 'asc']);
  };

  $scope.getInventoryBuyerTotal = function (inventory) {
    const buyerData = inventoryUtils.buyerTotal({
      inventoryType: inventory.type,
      price: inventory.price,
      taxPercent: inventory.tax,
      tipPercent: inventory.tip,
      ticketProcessingFee: $scope.venue.ticketProcessingFee,
      tableProcessingFee: $scope.venue.tableProcessingFee,
      fees: inventory.fees,
      depositAmount: inventory.depositAmount,
      paymentType: inventory.paymentType,
      userPaysProcessing: inventory.userPaysProcessing
    });

    return buyerData.total;
  };
  $scope.getInventoryDay = function (inventory) {
    const date = moment.utc(inventory.date, 'x');

    return date.format('dddd');
  };

  $scope.toggleHiddenInventory = function ($event) {
    if ($event) $event.preventDefault();

    $scope.hideHiddenInventory = !$scope.hideHiddenInventory;
  };

  $scope.setCurrentSection = function (type) {
    $scope.type = type;
  };

  $scope.migrateScheduleInventory = function (inventory) {
    inventory.schedulePopoverOpen = false;

    modalService.migrateInventory({
        inventory
      })
      .then(result => {
        if (result.inventory) {
          _extend(inventory, result.inventory);

          inventory.schedule = null;

          if (inventory.recurring.config.endDate) {
            inventory.recurringEndDate = moment.utc(inventory.recurring.config.endDate);
          }

          alertService.success(`Your ${inventory.type.toLowerCase()} has been migrated.`);
        }

        result.modalInstance.close();
      });
  };

  $scope.showInventoryQrCode = function (inventory, $event) {
    if ($event) $event.preventDefault();

    modalService.inventoryQrCode({
      inventory
    });
  };

  $scope.printInventoryQrCode = function (inventory, $event) {
    if ($event) $event.preventDefault();

    const formatter = new Intl.NumberFormat($scope.venue.languageCode, {
      style: 'currency',
      currency: $scope.venue.currencyCode || 'USD'
    });

    inventory.priceLocalized = formatter.format(inventory.price || 0);

    printService.printTemplate(printService.TEMPLATES.FAST_PASS_INVENTORY, {
      inventory,
      date: moment.utc(inventory.date).format('MMM. Do, YYYY'),
      venue: $scope.venue
    });
  };

  $scope.linkCopied = function (inventory, $event) {
    if (!inventory) return;
    if ($event) $event.preventDefault();

    inventory.showCopiedTooltip = true;
  };

  $scope.showWrkflowsArticle = function (article) {
    if (window.wrkflows) {
      window.wrkflows.showArticle(article);
    }

    $scope.fastpassPopoverOpen = false;
  };

  _initScope();

  function _initScope() {
    $scope.currentDateUTC = dateUtilsService.toUTCMomentWithoutTime($scope.date || moment.utc());

    $scope.loading = true;

    getInventory()
      .finally(() => {
        $scope.loading = false;
      });

    $scope.deleteInventory = function (inventory, $event) {
      if ($event) $event.preventDefault();

      const inventoryType = `${inventory.type.substring(0, 1).toUpperCase()}${inventory.type.substring(1, inventory.type.length).toLowerCase()}`;

      if ($scope.schedule) {
        modalService.confirmation({
            modalHeader: `Delete Recurring ${inventoryType}`,
            modalMessage: `<p>
              Are you sure you want to delete this recurring ${inventoryType}?
              </p>
              <p>
                <strong>Deleting this ${inventoryType} will delete all in the series.</strong>
            </p>`,
            confirmBtnTxt: 'Delete',
            confirmingBtnTxt: 'Deleting...',
            size: 'sm'
          })
          .then(result => {
            return deleteInventory(inventory.id)
              .then(() => {
                result.modalInstance.close();
              });
          });
      } else if (inventory.recurring && inventory.recurring.enable) {
        modalService.confirmationInventory({
            deleteMode: true,
            size: 'sm'
          })
          .then(result => {
            return deleteInventory(inventory.id, {
                disableRecurring: !result.confirm.maintainLink
              })
              .then(() => {
                if (result && result.modalInstance) {
                  result.modalInstance.close();
                }
              });
          });
      } else {
        modalService.confirmation({
            modalHeader: 'Delete Inventory',
            modalMessage: `Are you sure you want to delete this ${inventoryType}?`,
            confirmBtnTxt: 'Delete',
            confirmingBtnTxt: 'Deleting...',
            size: 'sm'
          })
          .then(result => {
            return deleteInventory(inventory.id)
              .then(() => {
                result.modalInstance.close();
              });
          });
      }
    };

    $scope.addOrUpdateInventory = function (inventory, $event) {
      if ($event) {
        $event.preventDefault();
      }

      modalService.addOrUpdateInventory({
        venue: $scope.venue,
        inventory,
        date: $scope.currentDateUTC,
        type: $scope.type,
        day: $scope.day ? $scope.day.number : undefined,
        schedule: $scope.schedule,
        onAddedOrUpdated: function (result) {
          if (!result || !result.inventory) return;

          if (!result.created) {
            const existingInventory = _find($scope.inventory, {
              id: result.inventory.id
            });

            if (result.inventory.recurring && result.inventory.recurring.enable && result.inventory.recurring.config.endDate) {
              result.inventory.recurringEndDate = moment.utc(result.inventory.recurring.config.endDate);
            } else {
              result.inventory.recurringEndDate = null;
            }

            _extend(existingInventory, result.inventory);
          } else {
            if (result.inventory.recurring && result.inventory.recurring.enable && result.inventory.recurring.config.endDate) {
              result.inventory.recurringEndDate = moment.utc(result.inventory.recurring.config.endDate);
            } else {
              result.inventory.recurringEndDate = null;
            }

            $scope.inventory.push(mapInventory(result.inventory));
          }
        }
      });
    };
  }

  function getInventory() {
    const promise = $scope.schedule ?
      scheduleService.listByVenueId($scope.venue.id) :
      inventoryService.list({
        venue: $scope.venue.id,
        start: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
        end: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC)
      });

    return promise
      .then(inventory => {
        inventory.forEach(inv => {
          inv.quantitySoldPercent = inventoryUtils.quantitySoldPercent(inv);

          if (inv.recurring && inv.recurring.enable && inv.recurring.config.endDate) {
            inv.recurringEndDate = moment.utc(inv.recurring.config.endDate);
          } else {
            inv.recurringEndDate = null;
          }
        });

        $scope.inventory = inventory.map(mapInventory);
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }

  function mapInventory(inv) {
    inv.fastPassUrl = `${config.FAST_PASS_URL}/express-checkout?inventoryId=${inv.id}`;

    return inv;
  }

  function deleteInventory(id, options) {
    if (!id) return null;

    const service = $scope.schedule ? scheduleService : inventoryService;

    const promise = service.deleteById(id, options);

    return promise
      .then((response) => {
        $scope.inventory = _reject($scope.inventory, item => {
          return item.id === response.id;
        });
      })
      .catch(response => {
        alertService.error(sdkUtils.getErrorFromResponse(response));
      });
  }
}

InventoryListCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  '$timeout',
  'jsSdk.venue',
  'jsSdk.inventory',
  'jsSdk.schedule',
  'jsSdk.utils',
  'permissionService',
  'dateUtilsService',
  'alertService',
  'visibilityHelpersService',
  'modalService',
  'angularSlideOutPanel',
  'printService'
];

export default InventoryListCtrl;



// WEBPACK FOOTER //
// ./src/directives/inventoryList/controller.js